<script lang="ts" setup>
import Transactions from "@/components/Transactions/index.vue";
</script>

<template>
  <main>
    <Transactions></Transactions>
  </main>
</template>
